export class EmailSubscriptionModel {
  emailAddress: string;
  initialOneRosterFilePlacement: boolean;
  oneRosterCriticalErrors: boolean;
  integrationsShutOffRequest: boolean;
  createdOn?: Date;
}
